export const LOCAL_STORAGE_KEYS = {
  videoPlayerVolume: 'video-player-volume',
  audioKitGiveawayNov24: 'audio-kit-giveaway-nov-2024',
};
